export enum StepSectionType {
  admin,
  baseData,
  a,
  b,
  c,
  d,
  e,
  f,
  g,
  h,
  i,
  j,
}

// export enum StepSectionType {
//   admin = 'admin',
//   baseData = 'baseData',
//   a = 'a',
//   b = 'b',
//   c = 'c',
//   d = 'd',
//   e = 'e',
//   f = 'f',
//   g = 'g',
//   h = 'h',
//   i = 'i',
//   j = 'j',
// }
